import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Servicios
import { EmpleadosServicio } from '../../../services/empleado.service';
import { RutasService } from '../../../services/rutas.service';
import { AlertasModales } from '../../../helpers/alertasModales';

@Component({
  selector: 'app-asignar-rutas-empleado',
  templateUrl: './asignar-rutas-empleado.component.html',
  styleUrls: ['./asignar-rutas-empleado.component.css']
})
export class AsignarRutasEmpleadoComponent implements OnInit {
  listadoRutas: Array<any>;
  loading: boolean;
  ruta: any;
  accion: string;
  @Input() empleado;
  @Input() rutasAsignadas;
  @Input() modals: AlertasModales;
  updated: boolean;

    constructor(
      public activeModal: NgbActiveModal,
      private empleadoService: EmpleadosServicio,
      private rutaService: RutasService) {
        rutaService.cargarTodasLasRutas().subscribe(resp => {
          if (resp) {
            this.listadoRutas = resp.rutas;

            for (const ruta of this.listadoRutas) {
              for (const ruta_asignada of this.rutasAsignadas) {
                if (ruta_asignada.ID_RUTA === ruta.ID_RUTA) {
                  ruta.ruta_asignada = true;
                }
              }
            }
          }
        });
    }

    ngOnInit() {
    }

    confirmarAsignacionRuta(item: any) {
      this.accion = (item.ruta_asignada ? 'revocarle' : 'asignarle');
      this.ruta = item;
    }

    revocarRutaEmpleado() {
      this.ruta = null;
    }

    asignarRutaEmpleado() {
      this.loading = true;

      this.rutaService
      .asignarRutaEmpleado(this.ruta, this.empleado.ID_EMPLEADO, this.empleadoService.datosEmpleado.ID_EMPLEADO).subscribe(() => {
        this.loading = false;
        this.updated = true;
        for (const ruta of this.listadoRutas) {
          if (ruta.ID_RUTA === this.ruta.ID_RUTA) {
            ruta.ruta_asignada = !ruta.ruta_asignada;
            break;
          }
        }
        this.ruta = null;
      }, err => {
        this.loading = false;
        if (err.status == 403) {
          this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
          'red',
          'modern',
          false,
          'fa fa-file-text');
        }
      });
    }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/asignar-rutas-empleado/asignar-rutas-empleado.component.ts